import React, { Component, useMemo } from 'react';
import { Col, Container, Row, Card, CardBody, ButtonToolbar, Button } from 'reactstrap';
//import Button from '@material-ui/core/Button';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import renderSelectField from '../../../../shared/components/form/Select';
import DataReactTable from './DataReactTable';
import AttachFileTableActions from './AttachFileTableActions';
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import history from '../../../../history';
import Spinner from 'react-bootstrap/Spinner';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import renderRadioButtonField from '../../../../shared/components/form/RadioButton';
import NotificationsSockets from '../../../Notifications/api/NotificationsSockets';
import { NotificationsAPI } from '../../../Notifications/api/NotificationsAPI';
import { HTMLNotification } from '../../../Notifications/components/HTMLNotification';
import ModalMessage from '../../../../shared/components/Modal';
import InfoPatient from '../../../ClinicHistory/SearchClinicHistory/components/InfoPatient';
import UploadingMultipleImages from './UploadingMultipleImages';
import { validateConfigurationsUserProfile } from '../../../Notifications/api/NotificationsUser';

class AttachFileAdmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            description: "",
            dataPatient: null,
            typeImg: 'institucional',
            date: new Date,
            data: [],
            errors: {},
            isLoading: true,
            isLoadingUpload: false,
            openAlert: false,
            modalAlert: { title: '', color: '', message: '' },
            filesImageData: []
        }
    };//

    componentDidMount() {
        this.setState({ dataPatient: this.props.location.state.dataPatient });
        console.log(this.props.location.state);
        this.getDataFiles();
    }

    validate = () => {
        var errors = {};
        var error = false;
        if (this.state.files.length <= 0) {
            errors.file = "Seleccione almenos un archivo";
            error = true;
        } else {
            errors.file = "";
        }

        console.log(this.state.files.length);
        console.log(error);

        this.setState({ errors: errors });
        return error;
    }

    uploadFile = async () => {
        if (!this.validate()) {
            this.setState({ isLoadingUpload: true });
            for (let i = 0; i < this.state.files.length; i++) {
                const user = JSON.parse(sessionStorage.getItem('usuario'));
                console.log();
                var dataFile = new FormData();
                dataFile.append("archivo", this.state.files[i]);
                dataFile.append("id_historia", parseInt(this.state.dataPatient.id_historia));
                dataFile.append("id_admision", parseInt(this.state.dataPatient.id_admision));
                dataFile.append("descripcion", this.state.description);
                dataFile.append("clase", 8);
                dataFile.append("tipo", this.state.typeImg);
                //dataFile.append("fecha", moment(this.state.date).format("YYYY/MM/DD"));
                //dataFile.append("hora", moment(this.state.date).format("HH:MM A"));
                dataFile.append("usuario", user.usuario);
                dataFile.append("tecnologo", user.id_usuario);
                await fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/create', {
                    method: 'POST',
                    headers: {
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: dataFile
                }).then(response => {
                    return response.text();
                }).then(data => {
                    //this.sendNotificationDiagnosticImage();  
                }).catch((error) => {
                    console.log(error);
                });
            }

            this.getDataFiles();
            this.setState({
                files: [],
                description: "",
                typeImg: '',
                openAlert: true,
                modalAlert: {
                    message: "Imagenes subidas correctamente",
                    color: 'success',
                    title: "Exitoso!"
                },
                isLoadingUpload: false
            });
        }
    }

    sendNotificationDiagnosticImage = async () => {
        try {
            validateConfigurationsUserProfile(this.props.location.state.dataPatient.id_usuario_profesional, 3).then((notConfig) => {
                if (notConfig.not_configuracion != null && notConfig.not_configuracion != undefined) {
                    console.log("notConfig", notConfig);
                    let usuario_conectado = JSON.parse(sessionStorage.getItem('usuario'));
                    let remitente = usuario_conectado.nombre.split(' ')[0] + ' ' + usuario_conectado.nombre.split(' ')[1];
                    let fecha_notificacion = moment().tz("America/Bogota").format("YYYY-MM-DD HH:mm:ss");
                    let notification = new NotificationsAPI();
                    notification.vista = false;
                    notification.id_usuario = this.props.location.state.dataPatient.id_usuario_profesional;
                    notification.id_admision = this.props.location.state.dataPatient.id_admision;
                    notification.id_historia = this.props.location.state.dataPatient.id_historia;
                    notification.asunto = "Imagen Diagnostica subida";
                    notification.remitente = remitente;
                    notification.notificacion = remitente + ' ha subido una Imagen Diagnostica del Paciente ' + this.props.location.state.dataPatient.fullname + ' en la Admision ' + this.props.location.state.dataPatient.id_admision;
                    notification.id_notificaciones_tipo = 3;
                    notification.fecha_notificacion = fecha_notificacion;
                    notification.addNotification().then((not) => {
                        let htmlNotificacion = new HTMLNotification();
                        notification.id_notificacion = not.notificacion.id_notificacion;
                        notification.html_notificacion = htmlNotificacion.notificationDiagnosticImages(fecha_notificacion, notification, this.props.location.state.dataPatient.fullname);
                        notification.sendHTMLNotification().then((res_not) => {
                            NotificationsSockets.sendNotification(notification);
                            return res_not;
                        }).catch((err) => {
                            console.log(err);
                            return false;
                        });
                    });
                }
                else {
                    return false;
                }
            }).catch((error) => {
                return false;
            })
        }
        catch (e) {
            console.log(e);
            return false;
        }
    }

    getDataFiles = () => {

        let dataSend = {
            id_historia: parseInt(this.props.location.state.dataPatient.id_historia),
            id_admision: parseInt(this.props.location.state.dataPatient.id_admision)
        };

        console.log(dataSend);
        fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar-imagenes', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("getDataFiles", data);
                this.setData(data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    renameFile = (originalFile, newName) => {
        return new File([originalFile], newName, { type: originalFile.type, lastModified: originalFile.lastModified });
    }

    setData = (data) => {

        let filterData = [];

        for (let i = 0; i < data.length; i++) {
            console.log("dataDocument", data[i]);
            filterData[i] = {

                clase: data[i].clase === "1" ? "CONSENTIMIENTO INFORMADO" :
                    data[i].clase === "2" ? "ECOCARDIOGRAMA MODO M" :
                        data[i].clase === "3" ? "ECOCARDIOGRAMA STRESS" :
                            data[i].clase === "4" ? "ELECTROCARDIOGRAMAS" :
                                data[i].clase === "5" ? "FORMULA MEDICA" :
                                    data[i].clase === "6" ? "HISTORIA CLINICA" :
                                        data[i].clase === "7" ? "HOLTER CARDIACO" :
                                            data[i].clase === "8" ? "IMAGENOLOGIA" :
                                                data[i].clase === "9" ? "LABORATORIO CLINICO" :
                                                    data[i].clase === "10" ? "MONITOREO DE PRESION ARTERIAL" :
                                                        data[i].clase === "11" ? "ORDEN MEDICA" :
                                                        data[i].clase === "12" ? "GAMAGRAFIAS" : 
                                                        data[i].clase === "13" ? "RESONANCIA NUCLERA MAGNETICA" : 
                                                        data[i].clase === "14" ? "DOCUMENTO DE IDENTIDAD" :
                                                        data[i].clase === "15" ? "AUTORIZACION" :
                                                        data[i].clase === "16" ? "OTROS" :
                                                        "",
                fecha: data[i].fecha,
                hora: data[i].hora,
                nombre: data[i].fileName,
                seleccionado: data[i].seleccionado,
                usuario: typeof data[i].usuario !== 'undefined' ? data[i].usuario : "",
                descripcion: data[i].descripcion,
                estado_documento: data[i].estado == 1 ? "PENDIENTE" : data[i].estado == 2 ? "APROBADO" : data[i].estado == 3 ? "RECHAZADO" : "",
                ruta: data[i].ruta,
                id: data[i].id,
                id_admision: this.props.location.state.dataPatient.id_admision,
                observacion_doctor: data[i].observacion_doctor
            }
        }
        this.setState({ data: filterData, isLoading: false });
    }

    handlerDate = (date) => {
        this.setState({ date: date });
    }

    createDatateble = (data) => {

        let filterData = [];

        for (let i = 0; i < data.length; i++) {
            if (data[i].archivos !== null) {
                for (let j = 0; j < data[i].archivos.archivos.length; j++) {
                    filterData.push(data[i].archivos.archivos[j]);
                }
            }
        }

        this.setData(filterData);
    }

    handlerFile = (file) => {
        this.setState({ file: file });
    };

    handlerTypeImage = (e) => {
        this.setState({
            typeImg: e
        });
    };

    handlerDesciption = (desc) => {
        this.setState({
            description: desc
        });
    };

    CallbackTable = () => {
        this.getDataFiles();
    }

    handleChargeImages = (value) => {
        this.setState({
            files: value
        }, () => {
            console.log("eDataFileState", this.state.files);
        });
    }

    render() {
        const reactTableData = {
            tableHeaderData: [
                {
                    Header: 'CLASE DE DOCUMENTO',
                    accessor: 'clase',
                    disableGlobalFilter: true,
                    width: 65,
                },
                {
                    Header: 'ESTADO DEL DOCUMENTO',
                    accessor: 'estado_documento',
                },
                {
                    Header: 'FECHA',
                    accessor: 'fecha',
                },
                {
                    Header: 'HORA',
                    accessor: 'hora',
                },
                {
                    Header: 'NOMBRE',
                    accessor: 'nombre',
                },
                {
                    Header: 'DESCRIPCIÓN',
                    accessor: 'descripcion',
                },
                {
                    Header: 'USUARIO',
                    accessor: 'usuario',
                },
                {
                    Header: 'SELECCIONADO',
                    accessor: 'seleccionado',
                    Cell: row => (
                        <label>{row.value == true ? <b className="text-success">SI</b> : <b className="text-danger">NO</b>}</label>
                    )
                },
                {
                    Header: 'OBSERVACION DEL DOCTOR',
                    accessor: 'observacion_doctor',
                }
            ],
            tableRowsData: this.state.data
        };

        const FilesList = () => {
            return (
                <DataReactTable
                    title={'Documentos Cargados'}
                    reactTableData={reactTableData}
                    ReactTableActions={AttachFileTableActions}
                    Callback={this.CallbackTable}
                    sendNotificationDiagnosticImage={this.sendNotificationDiagnosticImage}
                />)
        }

        return (
            <Container className="dashboard">
                {this.state.openAlert ?
                    <ModalMessage
                        color={this.state.modalAlert.color}
                        title={this.state.modalAlert.title}
                        message={this.state.modalAlert.message}
                        modal={this.state.openAlert}
                        toggle={() => { this.setState({ openAlert: !this.state.openAlert, description: '', files: [] }) }}
                        onOk={() => { this.setState({ openAlert: !this.state.openAlert, description: '', files: [] }) }}
                    /> : null}
                <Row>
                    <Col md={12}>
                        <h3 style={{ marginBottom: 30 }}>Anexar Imagenes Diagnosticas</h3>
                        <Button
                            style={{ marginBottom: 20 }}
                            color="primary"
                            size="sm"
                            onClick={() => {
                                history.push({
                                    //pathname: process.env.PUBLIC_URL + '/assitencial/admissions',
                                    pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
                                    state: {
                                        date: this.props.location.state.dataPatient.fecha,
                                        estado_list_form: this.props.location.state.dataPatient.estado_list_form,
                                        pageIndex: this.props.location.state.pageIndex
                                    }
                                });
                            }}
                        ><ArrowBackIcon />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Card>
                        <CardBody>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <label htmlFor="txtIndult"></label>

                            </div>
                            <div className="form" style={{ flexDirection: 'column' }}>
                                {/* <h4>INFORMACIÓN DE PACIENTE</h4>
                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                                    {this.state.dataPatient !== null ?
                                        <div style={{ display: 'flex' }}>
                                            <div style={{ marginRight: 10 }}><h4> {this.state.dataPatient.tip_documento}-{this.state.dataPatient.num_documento}</h4></div>
                                            <div><h4>{this.state.dataPatient.fullname} </h4> </div>
                                        </div> : null}
                                </div> */}
                                <InfoPatient dataPatient={this.props.location.state.dataPatient} />
                                <div>
                                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                                        {/*
                                        <div >
                                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                                <DatePicker
                                                    label="FECHA"
                                                    value={this.state.date}
                                                    style={{ width: 150 }}
                                                    onChange={(date) => {
                                                        this.handlerDate(date);
                                                    }}
                                                    format="yyyy/MM/DD"
                                                    animateYearScrolling
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        */}

                                        <div className="form__form-group" style={{ padding: '0em 1em 0.5em 1em' }}>
                                            <span className="form__form-group-label">
                                                AGREGAR ARCHIVO
                                            </span>

                                            <div className="form__form-group-field">
                                                {this.state.isLoadingUpload ? <Spinner animation="border" variant="success" /> :
                                                    <UploadingMultipleImages
                                                        images={this.state.files}
                                                        handleChargeImages={this.handleChargeImages}
                                                    />
                                                }
                                            </div>
                                            <span className="form__form-group-label" style={{ color: 'red' }}>
                                                {this.state.errors.hasOwnProperty("file") ? this.state.errors.file : ""}
                                            </span>
                                        </div>
                                    </div>

                                    <br />
                                    <br />

                                    <div className="form__form-group" style={{ padding: '0,25em 1em 0,25em 1em' }}>
                                        <span className="form__form-group-label">
                                            DESCRIPCIÓN
                                        </span>
                                        <div className="form__form-group-field">
                                            <Field
                                                name="textarea-description"
                                                component="textarea"
                                                type="text"
                                                value={this.state.description}
                                                onChange={(e) => {
                                                    this.handlerDesciption(e.target.value);
                                                }}
                                            />
                                        </div>
                                        <span className="form__form-group-label" style={{ color: 'red' }}>
                                            {this.state.errors.hasOwnProperty("description") ? this.state.errors.description : ""}
                                        </span>
                                    </div>

                                    <ButtonToolbar className="form__button-toolbar" style={{ padding: '0em 1em 0em 1em' }}>
                                        <Button
                                            style={{ marginBottom: 20 }}
                                            disabled={this.state.isLoadingUpload}
                                            color="primary"
                                            onClick={() => {
                                                this.uploadFile();
                                            }}
                                        >
                                            Confirmar
                                        </Button>
                                    </ButtonToolbar>
                                </div>
                            </div>
                            <div>
                                {this.state.isLoading ? (<Spinner animation="border" variant="success" />)
                                    : <FilesList />}

                            </div>
                        </CardBody>
                    </Card>
                </Row>
            </Container>);
    }
};

export default reduxForm({
    form: 'attach_file_admission_form', // a unique identifier for this form
})(withTranslation('common')(AttachFileAdmission));